var nurseslounge_continuingEducation = {
    init:function($params){
        var $userId = libs.memoryGet('user_id');
        $params = {user_id:$userId};
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_continuingEducation.menu_selector(function(){
            nurseslounge_continuingEducation.ce($params);
        });
    },
    menu_selector:function(cback){
        $("footer").hide();
        libs.globalUrl();
        cback();
    },
    ce:function($params){
        var $continuingEducation = $("#nurseslounge-continuingEducation");
        var $cards = $continuingEducation.find(".nurseslounge-continuingEducation-cards");
        var $specialties = $continuingEducation.find("select[name='specialties']");
        $specialties.hide();
        var $chtml = nurseslounge_continuingEducation.ce_html_preview();
        $cards.html($chtml).promise().done(function(){
            nurseslounge_continuingEducation.ce_request($params, function($data){
                var $chtml = nurseslounge_continuingEducation.ce_html($data);
                libs.checkImageLoad($($chtml).find('img'), function(){
                    $cards.html($chtml).promise().done(function(){
                        nurseslounge_continuingEducation.ce_events();
                    });
                });
            });
        });
    },
    ce_request:function($params, cback){
        $.ajax({
            url: "/continuingEducation/get",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'success'){
                    cback($data);
                }
            }
        });
    },
    ce_html_preview:function(){
        var $chtml = '';
        for(var $i=0; $i<2; $i++){
            $chtml += '' +
                '<div class="col-6 item float-left">' +
                '    <div class="card ce-card mb-4 pb-5">' +
                '        <div class="ce-card-image nurseslounge-continuingEducation-preload">' +
                '           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '        </div>' +
                '        <div class="ce-card-desc px-3">' +
                '            <h3 class="nurseslounge-continuingEducation-preload">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h3>' +
                '            <p class="nurseslounge-continuingEducation-preload">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>' +
                '        </div>' +
                '        <div class="ce-card-tags px-3">' +
                '            <div class="row my-1 nurseslounge-continuingEducation-preload">' +
                '               &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '            </div>' +
                '        </div>' +
                '    </div>' +
                '</div>';
        }
        return $chtml;
    },
    ce_html:function($data){
        var $chtml = '<div class="row m-0">';
        $.each($data.data.group, function($i, $v){
        var $widgets = $v.widgets;
        var $tag = $v.tag;
            $chtml += '' +
            '<div class="w-100 py-3 title">'+$tag+'</div>' +
            '   <div class="row col-10 offset-1 carousel">';
            $.each($widgets, function($widget_i, $widget_v){
                var $id = $widget_v.id;
                var $title = $widget_v.title;
                var $description = $widget_v.description_text;
                var $types = [];
                $.each($widget_v.specialties, function($i, $sv){
                    if($sv.specialty && $sv.specialty.type){
                        $types.push($sv.specialty.type);
                    }
                });
                var $states = [];
                $.each($widget_v.states, function($i, $sv){
                    $states.push($sv.state.state);
                });
                var $image = $widget_v.image_root_widget;
                //var $link = $widget_v.link;
                var $hours = $widget_v.hours ? $widget_v.hours : 0;
                var $rating = $widget_v.rating ? $widget_v.rating : 0;
                var $question = $widget_v.questions ? $widget_v.questions : 0;
                var $ceTags = [];
                if($types.length > 0) {
                    $.each($types, function($i, $widget_v){
                        $ceTags.push({tag:$widget_v});
                    });
                }
                if($states.length > 0) {
                    $.each($states, function($i, $widget_v){
                        $ceTags.push({tag:$widget_v});
                    });
                }
                if($hours > 0) {
                    $ceTags.push({tag:'Hours '+$hours});
                }
                if($rating > 0) {
                    $ceTags.push({tag:'Rating '+$rating});
                }
                if($question > 0) {
                    $ceTags.push({tag:'Question '+$question});
                }
                $description = $description.length > 500 ? $description.substr(0, 500) + '...' : $description;

                $chtml += '' +
                    '<div class="col-12 item" data-id="'+$id+'" ' +
                    '>' +
                    '   <div class="card ce-card mb-4 pb-5">' +
                    '     <div class="ce-card-image">' +
                    '         <img src="'+$image+'?resize=524x250" alt="continuing education image" class="img-fluid">' +
                    '     </div>'+
                    '     <div class="ce-card-desc px-3">' +
                    '         <h3>'+$title+'</h3>'+
                    '         <p>' + $description + '</p>' +
                    //'         <button type="button" class="open-button m-3 float-right">' +
                    //'             <i class="fa fa-book"></i>' +
                    //'         </button>' +
                    '     </div>' +
                    '     <div class="ce-card-tags px-3">';
                $.each($ceTags, function($sI, $sV){
                    $chtml += '<div class="tag">' + $sV.tag + '</div>';
                });
                $chtml += '' +
                    '       <div class="row my-1">' +
                    '           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                    '       </div>' +
                    '     </div>' +
                    '   </div>' +
                    '</div>';
            });
        $chtml += '' +
            '    </div>' +
            '</div>';
        });
        $chtml += '</div>';
        return $chtml;
    },
    ce_events:function(){
        var $userId = libs.memoryGet('user_id');
        var $carousels = $("#nurseslounge-continuingEducation .nurseslounge-continuingEducation-main .carousel");
        $carousels.unbind();
        $carousels.slick({
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
        var $continuingEducation = $("#nurseslounge-continuingEducation");
        var $main = $continuingEducation.find(".nurseslounge-continuingEducation-main");
        var $specialties = $continuingEducation.find("select[name='specialties']");
        $specialties.show();
        try{
            $specialties.chosen('destroy');
        }catch (e) {}
        $specialties.chosen();
        $specialties.unbind();
        $specialties.change(function(){
            $bindSearch = setTimeout(function(){
                var $params = $.extend({}, {
                    user_id:$userId,
                    search:$search.val(),
                    specialties:$specialties.val()
                });
                nurseslounge_continuingEducation.ce($params);
            }, 800);
        });
        var $item = $main.find(".item");
        $item.unbind().click(function(){
            var $that = $(this);
            var $id = $that.data('id');
            nurseslounge_myDashboard_continuingEducation.open_ce({
                user_id:$userId,
                id:$id
            });
        });
        var $search = $main.find('input[name="search"]');
        var $bindSearch;
        $search.unbind().on('keyup keydown keypress', function(){
            try{
                clearTimeout($bindSearch);
            }catch ($e) {

            }
            $bindSearch = setTimeout(function(){
                var $params = $.extend({}, {
                    user_id:$userId,
                    search:$search.val(),
                    specialties:$specialties.val()
                });
                nurseslounge_continuingEducation.ce($params);
            }, 2000);
        });
        nurseslounge_continuingEducation.ce_autocomplete(
            $search,
            {user_id:$userId},
            "/continuingEducation/autocomplete",
            function($keyword){
                try{
                    clearTimeout($bindSearch);
                }catch ($e) {

                }
                var $params = $.extend({}, {
                    user_id:$userId,
                    search:$keyword,
                    specialties:$specialties.val()
                });
                nurseslounge_continuingEducation.ce($params);
            }
        );
    },
    ce_autocomplete:function($target, $data, $url, cback){
        try {
            $($target).autocomplete("destroy");
        }catch (e) {
        }
        var $value = '';
        $($target).autocomplete({
            minLength	:2,
            search		: function(){
                $(this).addClass("ui-autocomplete-loading");
            },
            open 		: function(){
                $(this).removeClass("ui-autocomplete-loading");
            },
            source: function(request, response) {
                $.ajax({
                    method: 'POST',
                    url:$url,
                    data:$.extend({},{
                        keyword:$($target).val()
                    }, $data),
                    dataType: "json",
                    success: function($data){
                        libs.expire($data);
                        $value = '';
                        response($data);
                    }
                });
            },
            create:function(){
                $(this).prev().remove();
                $(this).trigger("keypress.autocomplete");
            },
            select: function (event, ui) {
                $value = ui.item.value;
                $(this).val($value);
                cback($value);
                return false;
            }
        }).keypress(function ($e) {
            if ($e.which == 13) {
                cback($(this).val());
                $(this).autocomplete("close");
            }
        });
    },
};
